// For constants used inside the api module
// Not to be included in index.ts or will lead to import loops
export const PASSPORT_BASE_URL = "https://passport.vidapp.com";
export const USER_BASE_URL = "https://user.vidapp.com";
